var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"app-code overflow-hidden",attrs:{"color":_vm.isDark ? '#1F1F1F' : 'grey lighten-5',"dark":_vm.isDark,"rounded":_vm.rounded,"dir":"ltr","outlined":""}},[_vm._t("default"),_c('app-copy-btn',{staticClass:"mr-n2 mt-n2",attrs:{"target":_vm.target}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }